import { render, staticRenderFns } from "./TOrganisationalScorecard.vue?vue&type=template&id=54ad0ee1&scoped=true"
import script from "./TOrganisationalScorecard.vue?vue&type=script&lang=js"
export * from "./TOrganisationalScorecard.vue?vue&type=script&lang=js"
import style0 from "./TOrganisationalScorecard.vue?vue&type=style&index=0&id=54ad0ee1&prod&lang=css"
import style1 from "./TOrganisationalScorecard.vue?vue&type=style&index=1&id=54ad0ee1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ad0ee1",
  null
  
)

export default component.exports